import type { FaireProductEntity } from "../../entity_types/product";

export const p_s5kj5vxsjg: FaireProductEntity = {
  token: "p_s5kj5vxsjg",
  type: "product",
  name: "Irid 18K Gold Non-Tarnish Multi CZ Statement Ring",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/c5a390d342a7fcc2f7fec2b09fbd258c8946a62660f677ee6d382a06cde4007b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ec83ddecb8b168b0b72c74f374aecd3e0a85fcb49db3faecc01e6b946b5dbea3.jpeg",
    "https://cdn.faire.com/fastly/52b35567e9ecb71f44047ad59f3006eac9566a0d43325b151e69761762eee593.jpeg",
    "https://cdn.faire.com/fastly/9019f23c506e1136b97baa2c8cde6f75029b43c8ee545e75b5a9e709c421e768.jpeg",
    "https://cdn.faire.com/fastly/c496eab5c69a84f7b3cba623d98cdf668e5cbee7fc81132b55e8bd801f47e3f6.jpeg",
  ],
  priceDollars: 7.96,
  description:
    "18K Gold Non-Tarnish Multi CZ Statement Ring\n18K Gold Plating\nStainless Steel\nCubic Zirconia\nSize 7 Measurement: 0.682 Diameter/2.14 Circumference\nSize 8 Measurement: 0.714 Diameter/2.24 Circumference\n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:29.849Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
